import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useNativeGeolocation } from './useNativeGeolocation';
import { logger } from '@/lib/logger';

export const useBackgroundLocation = () => {
  const { position } = useNativeGeolocation();

  useEffect(() => {
    if (!position) return;

    // Atualizar a cada 2 minutos
    const interval = setInterval(async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        await supabase.functions.invoke('update-user-location', {
          body: {
            user_id: user.id,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }
        });

        logger.info('Background location updated', {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      } catch (error) {
        logger.error('Failed to update background location', error);
      }
    }, 120000); // 2 minutos

    return () => clearInterval(interval);
  }, [position]);
};
